import { render, staticRenderFns } from "./PlaceOfIssue.vue?vue&type=template&id=6a47e214&scoped=true"
import script from "./PlaceOfIssue.vue?vue&type=script&lang=js"
export * from "./PlaceOfIssue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a47e214",
  null
  
)

export default component.exports